import { render, staticRenderFns } from "./planAccount.vue?vue&type=template&id=60b3261c&scoped=true"
import script from "./planAccount.vue?vue&type=script&lang=js"
export * from "./planAccount.vue?vue&type=script&lang=js"
import style0 from "./planAccount.vue?vue&type=style&index=0&id=60b3261c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b3261c",
  null
  
)

export default component.exports